import React from 'react';
import MainContent from '../components/MainContent';

const HomePage = () => {
    return (
        <>
            <MainContent />
        </>
    );
};

export default HomePage;